import React from 'react';
import ScheduleViewState from './scheduleViewContext/scheduleViewState/ScheduleViewState';
import ScheduleControlPanel from './components/ScheduleControlPanel/ScheduleControlPanel';
import ScheduleList from './components/ScheduleList/ScheduleList';
import SchedulePagination from './components/SchedulePagination/SchedulePagination';
import ModalWindows from './components/ModalWindows/ModalWindows';
import style from './ScheduleView.module.scss';

const ScheduleView: React.FC = () => {
	return (
		<ScheduleViewState>
			<div className={style.container} data-test="ScheduleView">
				<ScheduleControlPanel />
				<ScheduleList />
				<SchedulePagination />
				<ModalWindows />
			</div>
		</ScheduleViewState>
	);
};

export default ScheduleView;
